"use strict";
Shopify.contentCreator.accordion = {
    init: function () {
        var t = $(".accordion > dt > a, [data-cc-accordion] > dt > a");
        $(".accordion > dd, [data-cc-accordion] > dd").attr("aria-hidden", !0), t.attr("aria-expanded", !1), t.on("click", function () {
            var e = "false" === $(this).attr("aria-expanded");
            return $(this).attr("aria-expanded", e), $(this).parent().next().slideToggle(function () {
            }), $(this).parent().next().attr("aria-hidden", !e), !1
        }), t.on("keydown", function (t) {
            13 === (t.keyCode || e.which) && $(this).trigger("activate")
        })
    }, unload: function () {
        $(".accordion > dt > a, [data-cc-accordion] > dt > a").off("click activate"), $(".accordion > dt > a, [data-cc-accordion] > dt > a").off("keydown")
    }
}, Shopify.contentCreator.slideshow = {
    init: function () {
        $(".slider, .flexslider").find("li").unwrap(), $(".slider, .flexslider").flickity({pageDots: !0, lazyLoad: 2})
    }
}, Shopify.theme.animation = {
    init: function () {
        $("[data-scroll-class]").waypoint(function () {
            var e = $(this.element).data("scroll-class");
            $(this.element).addClass("animated").addClass(e)
        }, {offset: "70%"})
    }, slideTransition: function (e, t) {
        e.parents(".flickity-enabled").find(".animated").removeClass("animated " + t), e.addClass("animated").addClass(t)
    }, unload: function (e) {
        e.data("scroll-class", "")
    }
};
var deferred = {};
function floatToString(e, t) {
    var o = e.toFixed(t).toString();
    return o.match(/^\.\d+/) ? "0" + o : o
}
if (Shopify.theme.asyncView = {
        load: function (r, e, t) {
            var o, s = 2 < arguments.length && void 0 !== t ? t : {};
            if (r in deferred)return deferred[r];
            var l = $.Deferred();
            if (deferred[r] = l, s.hash && (o = sessionStorage.getItem(r))) {
                var i = JSON.parse(o);
                if (s.hash === i.options.hash)return delete deferred[r], l.resolve(i).promise()
            }
            return $.ajax({
                url: r,
                cache: !1,
                data: "view=".concat(e),
                dataType: "html",
                headers: {"cache-control": "no-cache"},
                success: function (e) {
                    var t = document.createElement("div");
                    t.innerHTML = e;
                    var o = JSON.parse(t.querySelector("[data-options]").innerHTML),
                        i = t.querySelectorAll("[data-html]"), a = {};
                    if (1 === i.length && "" === i[0].getAttribute("data-html")) a = i[0].innerHTML; else for (var n = 0; n < i.length; n++)a[i[n].getAttribute("data-html")] = i[n].innerHTML;
                    if (s.hash)try {
                        sessionStorage.setItem(r, JSON.stringify({options: o, html: a}))
                    } catch (e) {
                        console.error(e)
                    }
                    return delete deferred[r], l.resolve({options: o, html: a})
                },
                error: function () {
                    return delete deferred[r], l.reject()
                }
            }), l.promise()
        }
    }, Shopify.theme.breadcrumbs = {
        init: function (e) {
            if (1 < e) {
                var t = document.querySelector("[data-breadcrumb-text]"),
                    o = document.querySelector(".paginate").dataset.currentPage ? document.querySelector(".paginate").dataset.currentPage : 1,
                    i = document.querySelector(".paginate").dataset.paginatePages;
                document.querySelector(".js-breadcrumb-text").classList.remove("is-hidden"), t.innerHTML = "".concat(Shopify.translation.page_text, " ").concat(o, " ").concat(Shopify.translation.of_text, " ").concat(i)
            }
        }, unload: function () {
            document.querySelector(".js-breadcrumb-text").classList.add("is-hidden")
        }
    }, Shopify.theme.dropdownMenu = function () {
        ({$submenuInput: $(".has-submenu input")}).$submenuInput.on("click", function () {
            if ($(this).hasClass("is-opened")) {
                var e = $(this).closest("navbar-link").attr("href");
                window.location.href = e
            } else $(this).addClass("is-opened")
        })
    }, Shopify.theme.newsletterAjaxForm = {
        init: function () {
            $(".newsletter-form__wrapper .contact-form").each(function () {
                var t = $(this);
                t.on("submit", function (e) {
                    "true" !== $('input[name="challenge"]', t).val() && ($.ajax({
                        type: t.attr("method"),
                        url: t.attr("action"),
                        data: t.serialize(),
                        success: function () {
                            t.fadeOut("slow", function () {
                                t.prev(".form__success-message").html(Shopify.translation.newsletter_form_success)
                            })
                        },
                        error: function () {
                            $('input[name="challenge"]', t).val("true"), t.submit()
                        }
                    }), e.preventDefault())
                })
            })
        }, unload: function () {
            $(".newsletter-form__wrapper .contact-form").find(":submit").off()
        }
    }, Shopify.theme.getSectionData = function (e) {
        var t = e.attr("id").replace("shopify-section-", ""),
            o = e.find("[data-section-data][data-section-id=" + t + "]").first();
        if (!o)return {};
        var i = o.data("section-data") || o.html();
        try {
            return JSON.parse(i)
        } catch (e) {
            return console.warn("Sections: invalid section data found. ".concat(e.message)), {}
        }
    }, Shopify.theme.infiniteScroll = {
        init: function () {
            this.defaults = {
                grid: "[data-load-more--grid]",
                gridItems: "[data-load-more--grid-item]"
            }, $("body").on("click", "[data-load-more]", function (e) {
                e.preventDefault();
                var t = $(this), o = t.attr("href");
                Shopify.theme.infiniteScroll.loadNextPage(o, t)
            }), $("body").on("click", "[data-load-more-infinite]", function (e) {
                return Shopify.theme.infiniteScroll.enableInfinite(), $(this).remove(), e.stopPropagation(), !1
            }), $("[data-load-infinite-scroll]").length && Shopify.theme.infiniteScroll.enableInfinite()
        }, loadNextPage: function (e, i) {
            var a = this;
            $.ajax({
                type: "GET", dataType: "html", url: e, beforeSend: function () {
                    i.addClass("is-loading")
                }, success: function (e) {
                    i.removeClass("is-loading");
                    var t = $(e).find(a.defaults.gridItems), o = $(e).find("[data-load-more]").attr("href");
                    $("[data-load-more]").attr("href", o), $(a.defaults.grid).first().append(t), void 0 === o && $("[data-load-more]").addClass("is-hidden")
                }, error: function (e, t, o) {
                    console.log(e), console.log(t), console.log(o), location.replace(location.protocol + "//" + location.host + filterURL)
                }
            })
        }, enableInfinite: function () {
            new Waypoint.Infinite({
                element: $(this.defaults.grid)[0],
                items: "[data-load-more--grid-item]",
                more: "[data-load-infinite]",
                loadingClass: "loading-in-progress",
                onBeforePageLoad: function () {
                    $("[data-load-infinite]").removeClass("is-hidden")
                },
                onAfterPageLoad: function () {
                }
            })
        }, unload: function () {
            $("[data-load-more]").off(), $("[data-load-infinite]").off()
        }
    }, Shopify.theme.flickityIosFix = function () {
        var o, i = !1;
        document.body.addEventListener("touchstart", function (e) {
            $(this).closest(".flickity-slider") ? (i = !0, o = {x: e.touches[0].pageX, y: e.touches[0].pageY}) : i = !1
        }), document.body.addEventListener("touchmove", function (e) {
            if (i && e.cancelable) {
                var t = {x: e.touches[0].pageX - o.x, y: e.touches[0].pageY - o.y};
                7 < Math.abs(t.x) && e.preventDefault()
            }
        }, {passive: !1})
    }, Shopify.theme.loadScript = function (e, t, o) {
        Shopify.theme[e] || $.ajax({url: t, dataType: "script", success: o, async: !1})
    }, Shopify.theme.updateOptionsInSelector = function (e, t) {
        switch (e) {
            case 0:
                var o = "root";
                $(t + " .single-option-selector:eq(0)");
                break;
            case 1:
                o = $(t + " .single-option-selector:eq(0)").val(), $(t + " .single-option-selector:eq(1)");
                break;
            case 2:
                o = $(t + " .single-option-selector:eq(0)").val();
                o += " / " + $(t + " .single-option-selector:eq(1)").val();
                $(t + " .single-option-selector:eq(2)")
        }
        var i = Shopify.optionsMap[o];
        $(t + ' .swatch[data-option-index="' + e + '"] .swatch-element').each(function () {
            -1 !== $.inArray($(this).attr("data-value"), i) ? $(this).removeClass("soldout").find(":radio").removeAttr("disabled", "disabled").removeAttr("checked") : $(this).addClass("soldout").find(":radio").removeAttr("checked").attr("disabled", "disabled")
        })
    }, Shopify.linkOptionSelectors = function (e, t) {
        Shopify.optionsMap = {};
        for (var o = 0; o < e.variants.length; o++) {
            var i = e.variants[o];
            if (i.available) {
                if (Shopify.optionsMap.root = Shopify.optionsMap.root || [], Shopify.optionsMap.root.push(i.option1), Shopify.optionsMap.root = Shopify.uniq(Shopify.optionsMap.root), 1 < e.options.length) {
                    var a = i.option1;
                    Shopify.optionsMap[a] = Shopify.optionsMap[a] || [], Shopify.optionsMap[a].push(i.option2), Shopify.optionsMap[a] = Shopify.uniq(Shopify.optionsMap[a])
                }
                if (3 === e.options.length) {
                    a = i.option1 + " / " + i.option2;
                    Shopify.optionsMap[a] = Shopify.optionsMap[a] || [], Shopify.optionsMap[a].push(i.option3), Shopify.optionsMap[a] = Shopify.uniq(Shopify.optionsMap[a])
                }
            }
        }
        Shopify.theme.updateOptionsInSelector(0, t), 1 < e.options.length && Shopify.theme.updateOptionsInSelector(1, t), 3 === e.options.length && Shopify.theme.updateOptionsInSelector(2, t), $(t + " .single-option-selector:eq(0)").change(function () {
            return Shopify.theme.updateOptionsInSelector(1, t), 3 === e.options.length && Shopify.theme.updateOptionsInSelector(2, t), !0
        }), $(t + " .single-option-selector:eq(1)").change(function () {
            return 3 === e.options.length && Shopify.theme.updateOptionsInSelector(2, t), !0
        })
    }, Shopify.theme.applyMasonry = function (e, t) {
        var o = $(".gallery-type--masonry");
        0 < o.length && o.imagesLoaded().progress(function () {
            o.isotope({
                layoutMode: "masonry",
                itemSelector: e,
                percentPosition: !0,
                masonry: {columnWidth: e, gutter: t}
            })
        })
    }, Shopify.theme.applyHorizontalMasonry = function () {
        $(".gallery-type--horizontal-masonry").find(".gallery__item").each(function (e) {
            var t, o, i = $(this);
            setTimeout(function () {
                t = i.find("img").width(), o = i.find("img").height(), i.css("flex-basis", 200 * t / o), i.css("flex-grow", 200 * t / o), i.find("i").css("padding-bottom", o / t * 100 + "%")
            }, 100)
        })
    }, Shopify.theme.mobileMenu = {
        init: function () {
            this.$mobileMenuToggle = $("[data-show-mobile-menu]"), this.$mobileMenuIcon = $(".mobile-menu__toggle-icon"), this.$mobileDropDownToggle = $(".mobile-menu .close-dropdown"), $("body").on("click", '[data-show-mobile-menu="false"]', function () {
                Shopify.theme.mobileMenu.open()
            }), $("body").on("click", '[data-show-mobile-menu="true"]', function () {
                Shopify.theme.mobileMenu.close()
            }), $("body").on("click", ".mobile-menu-link", function (e) {
                e.preventDefault()
            }), !0 === Shopify.theme.jsHeader.enable_sticky && this.enableSticky()
        }, open: function () {
            var e = window.scrollY;
            $("body").attr("data-current-position", e);
            var t = 0, o = parseInt($(".mobile-header").height());
            void 0 !== Shopify.theme.jsAnnouncementBar && Shopify.theme.jsAnnouncementBar.enable_sticky && (t = Shopify.theme.jsAnnouncementBar.getAnnouncementHeight()), $(".mobile-menu").css({height: "calc(100vh - ".concat(o + t, "px)")}), this.$mobileMenuIcon.addClass("is-active"), $("[data-show-mobile-menu]").attr("data-show-mobile-menu", !0), void 0 !== Shopify.theme.jsAjaxCart && (Shopify.theme.jsAjaxCart.hideMiniCart(), Shopify.theme.jsAjaxCart.hideDrawer()), setTimeout(function () {
                $("body").addClass("mobile-menu--opened")
            }, 10)
        }, close: function () {
            $("body").removeClass("mobile-menu--opened");
            var e = $("body").data("current-position");
            window.scrollTo(0, e), this.$mobileMenuIcon.removeClass("is-active"), $("[data-show-mobile-menu]").attr("data-show-mobile-menu", !1)
        }, enableSticky: function () {
            Shopify.theme.jsHeader.disableSticky();
            var t = $("#mobile-header"), e = 0;
            void 0 !== Shopify.theme.jsAnnouncementBar && Shopify.theme.jsAnnouncementBar.enable_sticky && (e = Shopify.theme.jsAnnouncementBar.getAnnouncementHeight()), t.addClass("sticky--enabled"), t.sticky({
                wrapperClassName: "header-sticky-wrapper",
                zIndex: 40,
                topSpacing: e
            }).on("sticky-start", function () {
                var e = $("#mobile-header").height() + $(".announcement-sticky-wrapper").height();
                t.parent().parent().find(".search-overlay").addClass("sticky-search").css("top", e + "px")
            }).on("sticky-end", function () {
                t.parent().parent().find(".search-overlay").removeClass("sticky-search").css("top", "100%"), setTimeout(function () {
                    t.sticky("update")
                }, 250), t.find(".sticky-menu-wrapper").removeClass("is-visible")
            })
        }, disableSticky: function () {
            var e = $("#mobile-header");
            e.unstick(), e.removeClass("sticky--enabled"), setTimeout(function () {
                $(".header-sticky-wrapper").css("height", "auto")
            }, 250)
        }, unload: function () {
            $("[data-mobilemenu-toggle]").off(), $(".mobile-menu__toggle-icon").off(), $(".mobile-menu .close-dropdown").off(), this.disableSticky()
        }
    }, Shopify.theme.objectFitImages = {
        init: function () {
            objectFitImages(), "color" == Shopify.theme_settings.image_loading_style && this.calculateAspectRatio()
        }, calculateAspectRatio: function () {
            for (var e = document.querySelectorAll("[data-calculate-aspect-ratio]"), t = 0; t < e.length; t++) {
                var o = e[t].firstElementChild, i = o.getAttribute("width") / o.getAttribute("height"),
                    a = o.height * i;
                e[t].style.maxWidth = "".concat(Math.floor(a), "px")
            }
            document.addEventListener("lazyloaded", function (e) {
                e.srcElement.parentNode.style.background = "none"
            })
        }, unload: function () {
        }
    }, void 0 === Shopify)var Shopify = {};
if (Shopify.each = function (e, t) {
        for (var o = 0; o < e.length; o++)t(e[o], o)
    }, Shopify.map = function (e, t) {
        for (var o = [], i = 0; i < e.length; i++)o.push(t(e[i], i));
        return o
    }, Shopify.arrayIncludes = function (e, t) {
        for (var o = 0; o < e.length; o++)if (e[o] == t)return !0;
        return !1
    }, Shopify.uniq = function (e) {
        for (var t = [], o = 0; o < e.length; o++)Shopify.arrayIncludes(t, e[o]) || t.push(e[o]);
        return t
    }, Shopify.isDefined = function (e) {
        return void 0 !== e
    }, Shopify.getClass = function (e) {
        return Object.prototype.toString.call(e).slice(8, -1)
    }, Shopify.extend = function (e, t) {
        function o() {
        }

        o.prototype = t.prototype, e.prototype = new o, (e.prototype.constructor = e).baseConstructor = t, e.superClass = t.prototype
    }, Shopify.locationSearch = function () {
        return window.location.search
    }, Shopify.locationHash = function () {
        return window.location.hash
    }, Shopify.replaceState = function (e) {
        window.history.replaceState({}, document.title, e)
    }, Shopify.urlParam = function (e) {
        var t = RegExp("[?&]" + e + "=([^&#]*)").exec(Shopify.locationSearch());
        return t && decodeURIComponent(t[1].replace(/\+/g, " "))
    }, Shopify.newState = function (e, t) {
        return (Shopify.urlParam(e) ? Shopify.locationSearch().replace(RegExp("(" + e + "=)[^&#]+"), "$1" + t) : "" === Shopify.locationSearch() ? "?" + e + "=" + t : Shopify.locationSearch() + "&" + e + "=" + t) + Shopify.locationHash()
    }, Shopify.setParam = function (e, t) {
        Shopify.replaceState(Shopify.newState(e, t))
    }, Shopify.Product = function (e) {
        Shopify.isDefined(e) && this.update(e)
    }, Shopify.Product.prototype.update = function (e) {
        for (var t in e)this[t] = e[t]
    }, Shopify.Product.prototype.optionNames = function () {
        return "Array" == Shopify.getClass(this.options) ? this.options : []
    }, Shopify.Product.prototype.optionValues = function (o) {
        if (!Shopify.isDefined(this.variants))return null;
        var e = Shopify.map(this.variants, function (e) {
            var t = "option" + (o + 1);
            return null == e[t] ? null : e[t]
        });
        return null == e[0] ? null : Shopify.uniq(e)
    }, Shopify.Product.prototype.getVariant = function (i) {
        var a = null;
        return i.length != this.options.length || Shopify.each(this.variants, function (e) {
            for (var t = !0, o = 0; o < i.length; o++) {
                e["option" + (o + 1)] != i[o] && (t = !1)
            }
            return 1 == t ? void(a = e) : void 0
        }), a
    }, Shopify.Product.prototype.getVariantById = function (e) {
        for (var t = 0; t < this.variants.length; t++) {
            var o = this.variants[t];
            if (e == o.id)return o
        }
        return null
    }, Shopify.money_format = "${{amount}}", Shopify.formatMoney = function (e, t) {
        function n(e, t) {
            return void 0 === e ? t : e
        }

        function o(e, t, o, i) {
            if (t = n(t, 2), o = n(o, ","), i = n(i, "."), isNaN(e) || null == e)return 0;
            var a = (e = (e / 100).toFixed(t)).split(".");
            return a[0].replace(/(\d)(?=(\d\d\d)+(?!\d))/g, "$1" + o) + (a[1] ? i + a[1] : "")
        }

        "string" == typeof e && (e = e.replace(".", ""));
        var i = "", a = /\{\{\s*(\w+)\s*\}\}/, r = t || this.money_format;
        switch (r.match(a)[1]) {
            case"amount":
                i = o(e, 2);
                break;
            case"amount_no_decimals":
                i = o(e, 0);
                break;
            case"amount_with_comma_separator":
                i = o(e, 2, ".", ",");
                break;
            case"amount_with_apostrophe_separator":
                i = o(e, 2);
                break;
            case"amount_no_decimals_with_comma_separator":
                i = o(e, 0, ".", ",");
                break;
            case"amount_no_decimals_with_space_separator":
                i = o(e, 0, ".", " ")
        }
        return r.replace(a, i)
    }, Shopify.OptionSelectors = function (e, t) {
        return this.selectorDivClass = "selector-wrapper", this.selectorClass = "single-option-selector", this.variantIdFieldIdSuffix = "-variant-id", this.variantIdField = null, this.historyState = null, this.selectors = [], this.domIdPrefix = e, this.product = new Shopify.Product(t.product), this.onVariantSelected = Shopify.isDefined(t.onVariantSelected) ? t.onVariantSelected : function () {
        }, this.replaceSelector(e), this.initDropdown(), t.enableHistoryState && (this.historyState = new Shopify.OptionSelectors.HistoryState(this)), !0
    }, Shopify.OptionSelectors.prototype.initDropdown = function () {
        var e = {initialLoad: !0};
        if (!this.selectVariantFromDropdown(e)) {
            var t = this;
            setTimeout(function () {
                t.selectVariantFromParams(e) || t.fireOnChangeForFirstDropdown.call(t, e)
            })
        }
    }, Shopify.OptionSelectors.prototype.fireOnChangeForFirstDropdown = function (e) {
        this.selectors[0].element.onchange(e)
    }, Shopify.OptionSelectors.prototype.selectVariantFromParamsOrDropdown = function (e) {
        this.selectVariantFromParams(e) || this.selectVariantFromDropdown(e)
    }, Shopify.OptionSelectors.prototype.replaceSelector = function (e) {
        var t = document.getElementById(e), o = t.parentNode;
        Shopify.each(this.buildSelectors(), function (e) {
            o.insertBefore(e, t)
        }), t.style.display = "none", this.variantIdField = t
    }, Shopify.OptionSelectors.prototype.selectVariantFromDropdown = function (e) {
        var t = document.getElementById(this.domIdPrefix).querySelector("[selected]");
        if (!(t = t || document.getElementById(this.domIdPrefix).querySelector('[selected="selected"]')))return !1;
        var o = t.value;
        return this.selectVariant(o, e)
    }, Shopify.OptionSelectors.prototype.selectVariantFromParams = function (e) {
        var t = Shopify.urlParam("variant");
        return this.selectVariant(t, e)
    }, Shopify.OptionSelectors.prototype.selectVariant = function (e, t) {
        var o = this.product.getVariantById(e);
        if (null == o)return !1;
        for (var i = 0; i < this.selectors.length; i++) {
            var a = this.selectors[i].element, n = o[a.getAttribute("data-option")];
            null != n && this.optionExistInSelect(a, n) && (a.value = n)
        }
        return "undefined" != typeof jQuery ? jQuery(this.selectors[0].element).trigger("change", t) : this.selectors[0].element.onchange(t), !0
    }, Shopify.OptionSelectors.prototype.optionExistInSelect = function (e, t) {
        for (var o = 0; o < e.options.length; o++)if (e.options[o].value == t)return !0
    }, Shopify.OptionSelectors.prototype.insertSelectors = function (e, t) {
        Shopify.isDefined(t) && this.setMessageElement(t), this.domIdPrefix = "product-" + this.product.id + "-variant-selector";
        var o = document.getElementById(e);
        Shopify.each(this.buildSelectors(), function (e) {
            o.appendChild(e)
        })
    }, Shopify.OptionSelectors.prototype.buildSelectors = function () {
        for (var e = 0; e < this.product.optionNames().length; e++) {
            var t = new Shopify.SingleOptionSelector(this, e, this.product.optionNames()[e], this.product.optionValues(e));
            t.element.disabled = !1, this.selectors.push(t)
        }
        var i = this.selectorDivClass, a = this.product.optionNames();
        return Shopify.map(this.selectors, function (e) {
            var t = document.createElement("div");
            if (t.setAttribute("class", i), 1 < a.length) {
                var o = document.createElement("label");
                o.htmlFor = e.element.id, o.innerHTML = e.name, t.appendChild(o)
            }
            return t.appendChild(e.element), t
        })
    }, Shopify.OptionSelectors.prototype.selectedValues = function () {
        for (var e = [], t = 0; t < this.selectors.length; t++) {
            var o = this.selectors[t].element.value;
            e.push(o)
        }
        return e
    }, Shopify.OptionSelectors.prototype.updateSelectors = function (e, t) {
        var o = this.selectedValues(), i = this.product.getVariant(o);
        i ? (this.variantIdField.disabled = !1, this.variantIdField.value = i.id) : this.variantIdField.disabled = !0, this.onVariantSelected(i, this, t), null != this.historyState && this.historyState.onVariantChange(i, this, t)
    }, Shopify.OptionSelectorsFromDOM = function (e, t) {
        var o = t.optionNames || [], i = t.priceFieldExists || !0, a = t.delimiter || "/",
            n = this.createProductFromSelector(e, o, i, a);
        t.product = n, Shopify.OptionSelectorsFromDOM.baseConstructor.call(this, e, t)
    }, Shopify.extend(Shopify.OptionSelectorsFromDOM, Shopify.OptionSelectors), Shopify.OptionSelectorsFromDOM.prototype.createProductFromSelector = function (e, r, s, l) {
        if (!Shopify.isDefined(s)) s = !0;
        if (!Shopify.isDefined(l)) l = "/";
        var t = document.getElementById(e), o = t.childNodes, c = (t.parentNode, r.length), d = [];
        Shopify.each(o, function (e, t) {
            if (1 == e.nodeType && "option" == e.tagName.toLowerCase()) {
                var o = e.innerHTML.split(new RegExp("\\s*\\" + l + "\\s*"));
                0 == r.length && (c = o.length - (s ? 1 : 0));
                var i = o.slice(0, c), a = s ? o[c] : "", n = (e.getAttribute("value"), {
                    available: !e.disabled,
                    id: parseFloat(e.value),
                    price: a,
                    option1: i[0],
                    option2: i[1],
                    option3: i[2]
                });
                d.push(n)
            }
        });
        var i = {variants: d};
        if (0 == r.length) {
            i.options = [];
            for (var a = 0; a < c; a++)i.options[a] = "option " + (a + 1)
        } else i.options = r;
        return i
    }, Shopify.SingleOptionSelector = function (o, i, e, t) {
        this.multiSelector = o, this.values = t, this.index = i, this.name = e, this.element = document.createElement("select");
        for (var a = 0; a < t.length; a++) {
            var n = document.createElement("option");
            n.value = t[a], n.innerHTML = t[a], this.element.appendChild(n)
        }
        return this.element.setAttribute("class", this.multiSelector.selectorClass), this.element.setAttribute("data-option", "option" + (i + 1)), this.element.id = o.domIdPrefix + "-option-" + i, this.element.onchange = function (e, t) {
            t = t || {}, o.updateSelectors(i, t)
        }, !0
    }, Shopify.Image = {
        preload: function (e, t) {
            for (var o = 0; o < e.length; o++) {
                var i = e[o];
                this.loadImage(this.getSizedImageUrl(i, t))
            }
        }, loadImage: function (e) {
            (new Image).src = e
        }, switchImage: function (e, t, o) {
            if (e && t) {
                var i = this.imageSize(t.src), a = this.getSizedImageUrl(e.src, i);
                o ? o(a, e, t) : t.src = a
            }
        }, imageSize: function (e) {
            var t = e.match(/_(1024x1024|2048x2048|pico|icon|thumb|small|compact|medium|large|grande)\./);
            return null != t ? t[1] : null
        }, getSizedImageUrl: function (e, t) {
            if (null == t)return e;
            if ("master" == t)return this.removeProtocol(e);
            var o = e.match(/\.(jpg|jpeg|gif|png|bmp|bitmap|tiff|tif)(\?v=\d+)?$/i);
            if (null == o)return null;
            var i = e.split(o[0]), a = o[0];
            return this.removeProtocol(i[0] + "_" + t + a)
        }, removeProtocol: function (e) {
            return e.replace(/http(s)?:/, "")
        }
    }, Shopify.OptionSelectors.HistoryState = function (e) {
        this.browserSupports() && this.register(e)
    }, Shopify.OptionSelectors.HistoryState.prototype.register = function (t) {
        window.addEventListener("popstate", function (e) {
            t.selectVariantFromParamsOrDropdown({popStateCall: !0})
        })
    }, Shopify.OptionSelectors.HistoryState.prototype.onVariantChange = function (e, t, o) {
        this.browserSupports() && (!e || o.initialLoad || o.popStateCall || Shopify.setParam("variant", e.id))
    }, Shopify.OptionSelectors.HistoryState.prototype.browserSupports = function () {
        return window.history && window.history.replaceState
    }, Shopify.theme.productMedia = {
        models: [], setupMedia: function () {
            var o = {controls: ["zoom-in", "zoom-out", "fullscreen"], focusOnPlay: !1};
            $("model-viewer").each(function (e, t) {
                t = new Shopify.ModelViewerUI(t, o), Shopify.theme.productMedia.models.push(t)
            }), $(".product-gallery__model model-viewer").on("mousedown", function () {
                Shopify.theme.productMedia.hideModelIcon(this)
            })
        }, showModelIcon: function (e) {
            $(e).find(".button--poster, .model-icon-button-control").show()
        }, hideModelIcon: function (e) {
            $(e).find(".button--poster, .model-icon-button-control").hide()
        }
    }, Shopify.theme.productReviews = {
        init: function () {
            ($("#shopify-product-reviews").length || $(".shopify-product-reviews-badge").length) && SPR.$(document).ready(function () {
                return SPR.registerCallbacks(), SPR.initRatingHandler(), SPR.initDomEls(), SPR.loadProducts(), SPR.loadBadges()
            })
        }
    }, Shopify.theme.quantityBox = {
        init: function () {
            $("body").on("click", "[data-update-quantity]:not([disabled])", function () {
                Shopify.theme.quantityBox.updateQuantity($(this))
            }), $("body").on("keyup keydown change", ".quantity-input", function () {
                Shopify.theme.quantityBox.updateQuantity($(this))
            })
        }, updateQuantity: function (e) {
            var t = e.parents(".product-quantity-box"), o = $(".quantity-input", t),
                i = (t.parents("[data-line-item]").data("line-item"), parseInt(o.val())), a = 1e17,
                n = o.attr("min") || 0;
            if (null != o.attr("max") && (a = o.attr("max")), isNaN(i) || i < n)return o.val(n), !1;
            if (a < i)return o.val(a), !1;
            if ("plus" === e.data("update-quantity") ? i < a && (i++, o.val(i)) : "minus" === e.data("update-quantity") && n < i && (i--, o.val(i)), 1 === i || 0 === i ? ($(".quantity-minus", t).attr("disabled", !0), $(".quantity-plus", t).attr("disabled", !1)) : a <= i ? ($(".quantity-plus", t).attr("disabled", !0), $(".quantity-minus", t).attr("disabled", !1), o.val(a)) : ($(".quantity-minus", t).attr("disabled", !1), $(".quantity-plus", t).attr("disabled", !1)), e.parents("[data-line-item]").length) {
                var r = t.data("line-item-key");
                Shopify.theme.quantityBox.updateCart(r, i)
            }
        }, updateCart: function updateCart(lineID, quantity) {
            $(".quantity-warning").removeClass("animated bounceIn"), $.ajax({
                type: "POST",
                url: "/cart/change.js",
                data: "quantity=".concat(quantity, "&line=").concat(lineID),
                dataType: "json",
                success: function (e) {
                    var t = 0, o = "", i = $('[data-line-item="'.concat(lineID, '"]')).find(".quantity-warning"),
                        a = $('[data-line-item="'.concat(lineID, '"]')).find(".product-quantity-box"), n = lineID - 1;
                    void 0 !== e.items[n] && (t = e.items[n].quantity), 0 < quantity && quantity != t && (1 == t ? (o = Shopify.translation.product_count_one, i.text("".concat(t, " ").concat(o)), $(".quantity-minus", a).attr("disabled", !0)) : (o = Shopify.translation.product_count_other, i.text("".concat(t, " ").concat(o)))), i.addClass("animated bounceIn"), void 0 !== Shopify.theme.jsAjaxCart && Shopify.theme.jsAjaxCart.updateView(), Shopify.theme.jsCart && Shopify.theme.jsCart.updateView(e, lineID)
                },
                error: function error(XMLHttpRequest, textStatus) {
                    var response = eval("(" + XMLHttpRequest.responseText + ")");
                    response = response.description
                }
            }), setTimeout(function () {
              if($(".theme-ajax-cart--header-classic").hasClass("is-visible")){
                
              }else{
                location.reload()
              }
                
            }, 1e3)
        }, unload: function () {
            $(".quantity-input").off(), $("[data-update-quantity]").off()
        }
    }, Shopify.theme.queryParameters = {}, location.search.length)for (var aKeyValue, i = 0, aCouples = location.search.substr(1).split("&"); i < aCouples.length; i++)aKeyValue = aCouples[i].split("="), 1 < aKeyValue.length && (Shopify.theme.queryParameters[decodeURIComponent(aKeyValue[0])] = decodeURIComponent(aKeyValue[1]));
Shopify.theme.responsiveVideo = {
    init: function () {
        $('iframe[src*="youtube"]').each(function () {
            if (!$(this).parents(".plyr__video-wrapper, .featured-video").length) {
                if (this.closest(".lazyvideo"))return;
                Shopify.theme.responsiveVideo.getVideoElements(this, "youtube")
            }
        }), $('iframe[src*="vimeo"]').each(function () {
            if (!$(this).parents(".plyr__video-wrapper, .featured-video").length) {
                if (this.closest(".lazyvideo"))return;
                Shopify.theme.responsiveVideo.getVideoElements(this, "vimeo")
            }
        })
    }, getVideoElements: function (e, t) {
        var o = e.src;
        this.enable(e, o, t)
    }, enable: function (e, t, o) {
        $(e).parents(".lazyframe").length < 1 && $(e).wrap('<div class="lazyframe lazyframe--embedded-video" data-src="'.concat(t, '" data-vendor="').concat(o, '"></div>')), lazyframe(".lazyframe--embedded-video")
    }
};
var selectCallback = function (i, e) {
    var t = $(".product-" + e.product.id), o = $(".notify-form-" + e.product.id),
        a = $(".product_form, .shopify-product-form", t), n = a.data("variant-inventory"),
        r = $(".notify_form__inputs"), s = Shopify.translation.notify_form_email, l = Shopify.translation.contact_email,
        c = Shopify.translation.notify_form_send, d = r.data("url");
    if (i)var p = Shopify.translation.email_content + i.name + " | " + d + "?variant=" + i.id;
    if (r.hasClass("customer--true"))var u = Shopify.translation.customer_email,
        h = '\n      <input type="hidden" class="notify_email input" name="contact[email]" id="contact[email]" value="'.concat(u, '" />'); else h = '\n      <input required type="email" class="notify_email input" name="contact[email]" id="contact[email]" placeholder="'.concat(s, '" value="').concat(l, '" />');
    var f = '\n    <input type="hidden" name="challenge" value="false" />\n    <input type="hidden" name="contact[body]" class="notify_form_message" data-body="'.concat(p, '" value="').concat(p, '" />\n    <div class="field has-addons">\n      <div class="control">\n        ').concat(h, '\n      </div>\n      <div class="control">\n        <input class="action_button button" type="submit" value="').concat(c, '" />\n      </div>\n    </div>');
    i && i.featured_image && t.is(":visible") && $(".product-gallery__main, .js-gallery-modal", t).each(function () {
        var e = $(this), t = Flickity.data(this), o = $('[data-image-id="' + i.featured_image.id + '"]').data("index");
        e.is(":visible") && null != t && t.select(o, !1, !0)
    });
    if (a.find("[data-variant-selector]").trigger("selectedVariantChanged"), i)if (n && n.forEach(function (e) {
            e.id === i.id && (i.inventory_quantity = e.inventory_quantity, i.inventory_management = e.inventory_management, i.inventory_policy = e.inventory_policy)
        }), $(".sku", t).text(i.sku), Shopify.theme_settings.product_form_style)for (var m = 0, y = i.options.length; m < y; m++) {
        var v = a.find('.swatch[data-option-index="' + escape(m) + '"] :radio[value="' + i.options[m].replace(/\"/g, '\\"') + '"]');
        v.length && (v.get(0).checked = !0)
    } else $(".notify_form_message", t).attr("value", $(".notify_form_message", t).data("body") + " - " + i.title);
    if (i && 1 == i.available) {
        if (i.price < i.compare_at_price ? ($(".was-price", t).html('<span class="money">' + Shopify.formatMoney(i.compare_at_price, $("body").data("money-format")) + "</span>"), $(".savings", t).html(Shopify.translation.product_savings + " " + parseInt(100 * (i.compare_at_price - i.price) / i.compare_at_price) + '% (<span class="money">' + Shopify.formatMoney(i.compare_at_price - i.price, $("body").data("money-format")) + "</span>)"), $(".current_price", t).parent().addClass("sale")) : ($(".was-price", t).html(""), $(".savings", t).html(""), $(".current_price", t).parent().removeClass("sale")), i.inventory_management && 0 < i.inventory_quantity) {
            if (Shopify.theme_settings.display_inventory_left) {
                var g = Shopify.translation.product_count_other;
                1 == i.inventory_quantity && (g = Shopify.translation.product_count_one);
                var S = Shopify.theme_settings.inventory_threshold;
                i.inventory_quantity <= S ? $(".items_left", t).html(i.inventory_quantity + " " + g) : $(".items_left", t).html("")
            }
            Shopify.theme_settings.limit_quantity && "deny" == i.inventory_policy && $(".quantity", t).attr("max", i.inventory_quantity)
        } else $(".items_left", t).text(""), $(".quantity", t).removeAttr("max");
        $(".sold_out", t).text(""), $(".cart-warning", t).text(""), 0 < i.price ? $(".current_price", t).html('<span class="money">' + Shopify.formatMoney(i.price, $("body").data("money-format")) + "</span>") : $(".current_price", t).html(Shopify.translation.free_price_text), $("[data-add-to-cart-trigger]", t).removeClass("disabled").removeAttr("disabled").find("span:not(.icon)").text($("[data-add-to-cart-trigger]", t).data("label")), $(".shopify-payment-button", t).show(), $(".purchase-details__quantity", t).show(), o.hide(), r.empty(), r.append(f), Shopify.theme_settings.show_multiple_currencies && convertCurrencies()
    } else {
        var _ = i ? Shopify.translation.soldOut : Shopify.translation.unavailable;
        $(".was-price", t).text(""), $(".savings", t).text(""), $(".current_price", t).text(""), $(".items_left", t).text(""), $(".quantity", t).removeAttr("max"), $(".sold_out", t).text(_), $("[data-add-to-cart-trigger]", t).addClass("disabled").attr("disabled", "disabled").find("span:not(.icon)").text(_), $(".shopify-payment-button", t).hide(), $(".purchase-details__quantity", t).hide(), o.hide(), r.empty(), i && !i.available && (o.fadeIn(), r.empty(), r.append(f))
    }
}, globalQuickShopProduct;
function isScreenSizeLarge() {
    if ($(window).width() > Shopify.breakpoints.medium)return !0
}
Shopify.theme.predictiveSearch = {
    init: function () {
        $(".search-form input#q").val(""), $(".search-form input#q").on("keyup", function () {
            var o, e = null, i = $(this).val(), t = $(this);
            o = "products" == Shopify.theme_settings.search_option ? "".concat($("body").data("shop-url"), "/search?type=product&q=").concat(encodeURI(i)) : "".concat($("body").data("shop-url"), "/search?q=").concat(encodeURI(i)), $(".search-form").on("submit", function (e) {
                var t = encodeURI(i);
                e.preventDefault(), window.location.href = null == t ? "/search" : "".concat(o, "*")
            }), "" == i && $(this).find(".predictive-results").empty().css("opacity", 0), 3 < i.length ? (null != e && e.abort(), e = $.getJSON(o + "*&view=json", function (e) {
                console.log(e.results);
              
              var newresult = [];
              $.each(e.results, function(i, item) {
                var itemurl = item.url;
                
                
                var itemtrue = true;
                $.each(item.collections, function(it, itemc) {
                  if(itemc.handle == "hidden"){
                    itemtrue = false;
                  }
                })
                
                if (itemtrue != false){
                  if(item.object_type == "page" && itemurl.indexOf('bundle') > -1){
                    newresult.push(item);
                  }
                  if(item.object_type == "product"){
                    newresult.push(item);
                  }
                }
              });
              
              Shopify.theme.predictiveSearch.displayResults(newresult, o, i, t)
              
            })) : $(".search-form").find(".predictive-results").empty().css("opacity", 0)
        }), $(document).on("click", function (e) {
            var t = $(".search-form input#q");
            t.is(e.target) || 0 !== t.has(e.target).length || $(".predictive-results").css("opacity", 0).empty()
        })
    }, displayResults: function (e, t, o, i) {
        var a = i.parents(".search-form").find(".predictive-results");
        if (a.empty().css("opacity", 1), 0 < e.length) {
            for (var n = 0; n < Shopify.theme_settings.search_to_display; n++)if (null != e[n]) {
                var r = e[n], s = void 0, l = void 0, c = void 0;
                s = "product" == r.object_type ? (l = 1 == r.available ? 0 == r.raw_price ? Shopify.translation.free : r.price : Shopify.translation.sold_out, r.raw_compare > r.raw_price ? "\n              <span class='money'>".concat(l, "</span>\n              <span class='product-thumbnail__was-price was-price'>\n                <span class='money'>").concat(r.compare, "</span>\n              </span>") : "<span class='money'>".concat(l, "</span>")) : "<span>".concat(r.text_content), c = "" != r.thumbnail ? "<img class='lazyload transition--".concat(Shopify.theme_settings.image_loading_style, " result-image' src='").concat(r.thumbnail, "' alt='").concat(r.title, "'>") : "", a.append("\n          <li>\n            <a tabindex=0 class='result-link' href='".concat(r.url, "'>\n              ").concat(c, "\n              <div class='result-info'>\n                <p>").concat(r.title, "</p>\n                ").concat(s, "\n              </div>\n            </a>\n          </li>\n          "))
            }
            e.length > Shopify.theme_settings.search_to_display && a.append("<li><a tabindex=0 class='result-link' href='".concat(t, "*'>").concat(Shopify.translation.all_results, "</a></li>"))
        } else a.append("<li>".concat(Shopify.translation.no_results, "</li>"))
    }, unload: function () {
        $(".search-form").off(), $(".search-form input#q").off()
    }
}, Shopify.theme.scrollToTop = function (e, t) {
    null != t ? $("html, body").animate({scrollTop: $(e).offset().top - t}, 1e3) : $("html, body").animate({scrollTop: $(e).offset().top}, 1e3)
}, Shopify.theme.tabs = {
    enableTabs: function () {
        var i = $(".tabs li, .tabs li a");
        i.on("click", function (e) {
            e.preventDefault(), i.removeClass("is-active active"), $(this).addClass("is-active");
            var t = $(this).index(), o = $(this).parents(".tabs").next(".tabs-content");
            o.children("li, li a").removeClass("is-active active"), o.children("li, li a").eq(t).addClass("is-active").show().css({display: "block"}).siblings().hide().removeClass("is-active")
        })
    }, unload: function () {
        $(".tabs li, .tabs li a").off()
    }
}, Shopify.theme.thumbnail = {
    enableSwatches: function () {
        isScreenSizeLarge() && $("body").on("mouseenter", ".swatch span", function () {
            -1 == $(this).data("image").indexOf("no-image") && ($(this).parents(".thumbnail").find(".product__imageContainer img:not(.secondary)").attr("src", $(this).data("image")), $(this).parents(".thumbnail").find(".product__imageContainer img:not(.secondary)").attr("srcset", $(this).data("image")))
        })
    }, showVariantImage: function () {
        isScreenSizeLarge() && ($("body").on("mouseenter", ".has-secondary-image-swap", function () {
            var e = $(this).find(".product-image__wrapper img"),
                t = $(this).find(".product-image__wrapper .video-on-hover");
            e && e.toggleClass("swap--visible"), t && (t.toggleClass("swap--visible"), Shopify.theme.video.enableVideoOnHover($(this)))
        }), $("body").on("mouseleave", ".has-secondary-image-swap", function () {
            var e = $(this).find(".product-image__wrapper img"),
                t = $(this).find(".product-image__wrapper .video-on-hover");
            e && e.toggleClass("swap--visible"), t && (t.toggleClass("swap--visible"), Shopify.theme.video.disableVideoOnHover($(this)))
        }))
    }, showQuickShop: function () {
        $("body").on("click", ".js-quick-shop-link", function (e) {
            e.preventDefault();
            var a = {
                    handle: $(this).data("handle"),
                    product_id: $(this).data("id"),
                    single_variant: $(this).attr("data-single-variant"),
                    product_in_collection_url: $(this).data("url"),
                    escaped_title: $(this).data("title"),
                    details_text: $(this).data("details-text"),
                    full_description: $(this).data("full-description"),
                    regular_description: $(this).data("regular-description"),
                    featured_image: $(this).data("featured-image"),
                    image_array: Shopify.theme.thumbnail.createImageObjects($(this).data("images")),
                    thumbnail_array: Shopify.theme.thumbnail.createImageObjects($(this).data("thumbnail-images")),
                    collection_handles: $(this).data("collection-handles").trim(",").split(","),
                    money_format: $("body").data("money-format")
                }, o = $(this).next(".js-quickshop-forms__container").find(".notify_form"),
                i = $(this).next(".js-quickshop-forms__container").find(".product_form");
            $(".fancybox-active").length || $.fancybox.open($(".js-quick-shop"), {
                baseClass: "quick-shop__lightbox product-" + a.product_id,
                hash: !1,
                infobar: !1,
                toolbar: !1,
                loop: !0,
                smallBtn: !0,
                touch: !1,
                video: {autoStart: !1},
                mobile: {preventCaptionOverlap: !1, toolbar: !0},
                beforeLoad: function (e, t) {
                    var o = t.src, i = $(o).find(".quick-shop");
                    i.hasClass("content-loaded") || Shopify.theme.thumbnail.beforeOpen(a, i)
                },
                afterLoad: function (e, t) {
                    0 < $(".tabs").length && Shopify.theme.tabs.enableTabs(), Shopify.theme.thumbnail.afterContent(i, o, a, t), Shopify.theme.jsProduct.enableProductSwatches(), Shopify.theme.productMedia.setupMedia()
                },
                afterShow: function (e, t) {
                    var o = t.src;
                    $(o).find(".quick-shop").addClass("quick-shop--loaded")
                },
                beforeClose: function (e, t) {
                    var o = t.src, i = $(o).find(".quick-shop");
                    Shopify.theme.thumbnail.beforeClose(a, i), i.removeClass("quick-shop--loaded"), $("body").removeClass("model-loaded")
                }
            })
        })
    }, beforeClose: function (e, t) {
        t.closest(".js-quick-shop").removeClass("content-loaded");
        var o = $(".quick-shop__lightbox .notify_form"), i = $(".quick-shop__lightbox .product_form");
        $(".js-quickshop-forms--".concat(e.product_id)).append(i), $(".js-quickshop-forms--".concat(e.product_id)).append(o), $(".js-quickshop-forms--".concat(e.product_id, " .product_form")).addClass("viewed"), $(".js-quickshop-forms--".concat(e.product_id, " .notify_form")).addClass("viewed"), $(".quick-shop .thumbnail-sticker span").empty().parent().addClass("is-hidden");
        var a = t.find(".js-gallery-modal"), n = t.find(".js-gallery-carousel");
        n.find(".gallery-cell").off("click"), a.flickity("remove", $(".gallery-cell", a)), n.empty(), a.flickity("destroy");
        var r = $(".js-current-price .money").text();
        $(".js-quick-shop-link[data-id=".concat(e.product_id, "]")).attr("data-initial-modal-price", r), $(".js-current-price, .js-was-price, .js-savings").empty(), !0 === a.data("zoom") && a.trigger("zoom.destroy")
    }, afterContent: function (e, t, o, i) {
        var a = i.src, n = $(a).find(".js-gallery-modal");
        n.closest(".js-quick-shop").addClass("content-loaded"), Shopify.theme.thumbnail.retrieveProductInfo(o);
        var r = {
            thumbnailsEnabled: n.data("thumbnails-enabled"),
            thumbnailsSliderEnabled: n.data("thumbnails-slider-enabled"),
            thumbnailsPosition: n.data("thumbnails-position"),
            arrowsEnabled: n.data("gallery-arrows-enabled"),
            slideshowAnimation: n.data("slideshow-animation"),
            slideshowSpeed: n.data("slideshow-speed")
        };
        if (Shopify.theme.jsProduct.enableSlideshow(n, r), Shopify.theme.video.init(), $(".quick-shop__lightbox .js-notify-form").append(t), $(".quick-shop__lightbox .js-product-form").append(e), e.hasClass("product_form_options") && !e.hasClass("viewed") ? new Shopify.OptionSelectors(e.data("select-id"), {
                product: e.data("product"),
                onVariantSelected: selectCallback,
                enableHistoryState: e.data("enable-state")
            }) : Shopify.theme_settings.show_multiple_currencies && convertCurrencies(), "swatches" == Shopify.theme_settings.product_form_style) {
            var s = e.data("product"), l = ".product-" + o.section_id + " .js-product_section";
            1 < e.find(".swatch_options .swatch").length && Shopify.linkOptionSelectors(s, l)
        }
        0 < $(".single-option-selector").length && ($(".selector-wrapper").wrap('<div class="select"></div>'), $("#product-form-" + o.product_id + " .select-container").children().first().removeClass("select").addClass("select-container")), $('.js-quick-shop select[name="id"]').trigger("change")
    }, createImageObjects: function (e) {
        return e.split("~").map(function (e) {
            var t = e.split("^");
            return {path: t[0], alt: t[1], id: t[2], width: t[3]}
        })
    }, beforeOpen: function (e, t) {
        Shopify.theme.thumbnail.populateGallery(e, t), $(".js-sale-sticker, .js-sold-out, .js-current-price, .js-was-price, .js-savings, .js-new-sticker, .js-pre-order-sticker").empty(), $(".modal_price, .js-notify-form").show()
    }, retrieveProductInfo: function (t) {
        $.ajax({
            dataType: "json", async: !1, cache: !1, url: "/products/" + t.handle + ".js", success: function (e) {
                e = $.extend({}, e, t), globalQuickShopProduct = e, Shopify.theme.thumbnail.updateVariant(e.variants[0].id.toString(), e)
            }
        })
    }, populateGallery: function (r, e) {
        var s = e.find(".js-gallery-modal"), l = e.find(".js-gallery-carousel");
        $.each(r.image_array, function (e, t) {
            if ("" == t.path || null == t.id)var o = r.featured_image, i = ""; else o = t.path, i = t.alt;
            var a;
            o.replace(/(\.[^.]*)$/, "_2048x2048$1").replace("http:", "");
            a = 0 <= i.indexOf("model") || 0 <= i.indexOf("video") ? unescape(o) : '\n            <div class="image__container" style="max-width: '.concat(t.width, 'px">\n              <img src="').concat(o, '" alt="').concat(i, '" data-image-id="').concat(t.id, '" data-index="').concat(e, '" />\n            </div>\n          ');
            var n = $('<div class="gallery-cell">' + a + "</div>");
            s.append(n)
        }), 0 == l.find(".gallery-cell").length && 1 < s.find(".gallery-cell").length && $.each(r.thumbnail_array, function (e, t) {
            if ("" != t.path) {
                var o = t.path.replace(/(\.[^.]*)$/, "_grande$1").replace("http:", ""), i = "";
                0 <= t.alt.indexOf("model") ? i = '<span class="icon media-badge"><svg width="26" height="26" viewBox="0 0 26 26" fill="none" xmlns="http://www.w3.org/2000/svg"><path fill-rule="evenodd" clip-rule="evenodd" d="M1 25H25V1H1V25Z" fill=""/><path class="media-badge__outline" d="M0.5 25V25.5H1H25H25.5V25V1V0.5H25H1H0.5V1V25Z" stroke="" stroke-opacity="0.05"/><g opacity="0.6"><path fill-rule="evenodd" clip-rule="evenodd" d="M13 6L19.0622 9.5V16.5L13 20L6.93782 16.5V9.5L13 6Z" stroke="" stroke-width="1.5"/><path fill-rule="evenodd" clip-rule="evenodd" d="M13 20V12.6024C13.6225 12.2002 13.6225 12.2002 13.6225 12.2002L19 9V16.4082L13 20Z" fill=""/></g></svg></span>' : (0 <= t.alt.indexOf("external_video") || 0 <= t.alt.indexOf("video")) && (i = '<span class="icon media-badge"><svg width="26" height="26" viewBox="0 0 26 26" fill="none" xmlns="http://www.w3.org/2000/svg"><path fill-rule="evenodd" clip-rule="evenodd" d="M1 25H25V1H1V25Z" fill=""/><path class="media-badge__outline" d="M0.5 25V25.5H1H25H25.5V25V1V0.5H25H1H0.5V1V25Z" stroke="" stroke-opacity="0.05"/><path fill-rule="evenodd" clip-rule="evenodd" d="M8.19995 5.8V20.2L19.3999 12.5858L8.19995 5.8Z" fill="" fill-opacity="0.6"/></svg></span>');
                var a = '<img src="' + o + '" alt="' + escape(t.alt) + '" />',
                    n = $('<div class="gallery-cell" tabindex="0">' + a + i + "</div>");
                l.append(n)
            }
        }), !0 === s.data("zoom") && s.find("img").wrap('<span class="zoom-container"></span>').css("display", "block").parent().zoom({touch: !1})
    }, updateVariant: function () {
        if ("undefined" != globalQuickShopProduct) {
            var e = function (e) {
                e.id == e.id.toString() && (Shopify.theme_settings.stickers_enabled && e.compare_at_price > e.price && $(".sale-sticker span").html(Shopify.translation.sale).parent().removeClass("is-hidden"), e.compare_at_price > e.price ? $(".js-current-price").addClass("sale") : $(".js-current-price").removeClass("sale"), 0 == e.available ? -1 != t.collection_handles.indexOf("coming-soon") ? Shopify.theme_settings.stickers_enabled || $(".js-sold-out").html(Shopify.translation.coming_soon) : $(".js-sold-out").html(Shopify.translation.sold_out) : $(".js-sold-out").html(""), 1 == e.available ? ($(".js-notify-form").hide(), e.compare_at_price > e.price && ($(".js-was-price").html('<span class="money">' + Shopify.formatMoney(e.compare_at_price, t.money_format) + "</span>"), $(".js-savings").html(Shopify.translation.savings + " " + parseInt(100 * (e.compare_at_price - e.price) / e.compare_at_price) + '% (<span class="money">' + Shopify.formatMoney(e.compare_at_price - e.price, t.money_format) + "</span>)")), t.price == Shopify.translation.coming_soon ? $(".js-current-price").html(Shopify.translation.coming_soon) : e.price ? $(".js-current-price").html('<span class="money">' + Shopify.formatMoney(e.price, t.money_format) + "</span>") : $(".js-current-price").html(Shopify.translation.free_price_text), Shopify.theme_settings.show_multiple_currencies && convertCurrencies()) : $(".js-notify-form").show())
            }, t = globalQuickShopProduct;
            $(".js-current-price").html(""), $(".js-was-price").html(""), $(".js-savings").html(""), $(".js-product-title").html('<a href="' + t.product_in_collection_url + '" title="' + t.escaped_title + '">' + t.title + "</a>"), $(".js-product-vendor").html('<a href="/collections/vendors?q=' + t.vendor + '">' + t.vendor + "</a>"), $(".js-full-description").html(t.full_description), $(".js-regular-description").html(t.regular_description);
            var o = '<a href="' + t.product_in_collection_url + '" class="secondary_button" title="' + t.escaped_title + ' Details">' + t.details_text + "</a>";
            if ($(".js-product-details").html(o), Shopify.theme_settings.stickers_enabled && $.each(t.collection_handles, function (e, t) {
                    switch (this.toString()) {
                        case"best-seller":
                            $(".best-seller-sticker span").html(Shopify.translation.best_seller).parent().removeClass("is-hidden");
                            break;
                        case"coming-soon":
                            $(".coming-soon-sticker span").html(Shopify.translation.coming_soon).parent().removeClass("is-hidden");
                            break;
                        case"new":
                            $(".new-sticker span").html(Shopify.translation.new_sticker).parent().removeClass("is-hidden");
                            break;
                        case"pre-order":
                            $(".pre-order-sticker span").html(Shopify.translation.pre_order).parent().removeClass("is-hidden");
                            break;
                        case"staff-pick":
                            $(".staff-pick-sticker span").html(Shopify.translation.staff_pick).parent().removeClass("is-hidden")
                    }
                }), "true" == t.single_variant) e(t); else for (var i = 0; i < t.variants.length; i++)e(t.variants[i])
        }
    }
};
var videoEl = {
        playButtonIcon: '<button type="button" class="plyr__control plyr__control--overlaid" aria-label="Play, {title}" data-plyr="play"><svg class="play-icon-button-control" width="60" height="60" viewBox="0 0 60 60" fill="none" xmlns="http://www.w3.org/2000/svg"><rect width="60" height="60" fill="white"/><path fill-rule="evenodd" clip-rule="evenodd" d="M23 20V40L39 29.4248L23 20Z" fill="#323232"/></svg><span class="plyr__sr-only">Play</span></button>',
        playButton: '<button type="button" class="plyr__controls__item plyr__control" aria-label="Play, {title}" data-plyr="play"><svg class="icon--pressed" role="presentation"><use xlink:href="#plyr-pause"></use></svg><svg class="icon--not-pressed" role="presentation"><use xlink:href="#plyr-play"></use></svg><span class="label--pressed plyr__tooltip" role="tooltip">Pause</span><span class="label--not-pressed plyr__tooltip" role="tooltip">Play</span></button>',
        muteButton: '<button type="button" class="plyr__controls__item plyr__control" aria-label="Mute" data-plyr="mute"><svg class="icon--pressed" role="presentation"><use xlink:href="#plyr-muted"></use></svg><svg class="icon--not-pressed" role="presentation"><use xlink:href="#plyr-volume"></use></svg><span class="label--pressed plyr__tooltip" role="tooltip">Unmute</span><span class="label--not-pressed plyr__tooltip" role="tooltip">Mute</span></button>',
        progressInput: '<div class="plyr__controls__item plyr__progress__container"><div class="plyr__progress"><input data-plyr="seek" type="range" min="0" max="100" step="0.01" value="0" aria-label="Seek"><progress class="plyr__progress__buffer" min="0" max="100" value="0">% buffered</progress><span role="tooltip" class="plyr__tooltip">00:00</span></div></div>',
        volume: '<div class="plyr__controls__item plyr__volume"><input data-plyr="volume" type="range" min="0" max="1" step="0.05" value="1" autocomplete="off" aria-label="Volume"></div>',
        fullscreen: '<button type="button" class="plyr__controls__item plyr__control" data-plyr="fullscreen"><svg class="icon--pressed" role="presentation"><use xlink:href="#plyr-exit-fullscreen"></use></svg><svg class="icon--not-pressed" role="presentation"><use xlink:href="#plyr-enter-fullscreen"></use></svg><span class="label--pressed plyr__tooltip" role="tooltip">Exit fullscreen</span><span class="label--not-pressed plyr__tooltip" role="tooltip">Enter fullscreen</span></button>'
    },
    videoControls = "".concat(videoEl.playButtonIcon, '<div class="plyr__controls"> ').concat(videoEl.playButton, " ").concat(videoEl.progressInput, " ").concat(videoEl.muteButton, " ").concat(videoEl.volume, " ").concat(videoEl.fullscreen, "</div>"),
    videoPlayers = [], videosInRecommendedProductsPlayer;
Shopify.theme.video = {
    init: function () {
        this.setupVideoPlayer()
    }, setupVideoPlayer: function () {
        var e = document.querySelectorAll("[data-html5-video] video, [data-youtube-video]"), t = Plyr.setup(e, {
            controls: videoControls,
            ratio: this.aspect_ratio,
            fullscreen: {enabled: !0, fallback: !0, iosNative: !0},
            storage: {enabled: !1}
        }), o = $("[data-video-loop]").data("video-loop") || !1;
        $.each(t, function (e, t) {
            t.loop = o, videoPlayers.push(t)
        }), this.setupListeners()
    }, setupListeners: function () {
        $.each(videoPlayers, function (e, t) {
            var o = t.id;
            t.isHTML5 && $(t.elements.wrapper).find("video").attr("data-plyr-video-id", o), t.on("play", function (e) {
                var i = e.detail.plyr;
                $.each(videoPlayers, function (e, t) {
                    var o = t.id || t.media.dataset.plyrVideoId;
                    i.id != o && t.pause()
                })
            })
        })
    }, enableVideoOnHover: function (e) {
        var o, t = e.find("[data-html5-video]"), i = e.find("[data-youtube-video]");
        0 < t.length ? o = t.find("[data-plyr-video-id]").data("plyr-video-id") : 0 < i.length && (o = i.find("iframe").attr("id")), o && $.each(videoPlayers, function (e, t) {
            t.id != o && t.media.id != o || (t.toggleControls(!1), t.muted = !0, t.play())
        })
    }, disableVideoOnHover: function (e) {
        var o, t = e.find("[data-html5-video]"), i = e.find("[data-youtube-video]");
        0 < t.length ? o = t.find("[data-plyr-video-id]").data("plyr-video-id") : 0 < i.length && (o = i.find("iframe").attr("id")), o && $.each(videoPlayers, function (e, t) {
            t.id != o && t.media.id != o || t.playing && t.pause()
        })
    }
};